function checkUnusualColis(arrayOfColis) {
	return arrayOfColis.includes("ER") || arrayOfColis.includes("CR");
}

exports.checkUnusualColis = checkUnusualColis;
